import classNames from "classnames";
import { LanguagesAbbr, PageModule, PageModuleType, TranslateString } from "../../../../../../types/working-model";
import Icon, { COLORS, ICONS } from "../../../../../general-ui/icon";
import { useMemo } from "react";
import { useHistoryState } from "utils/use-history-state";
import "./engage-header.scss";

export type EngageLabelInfo = {
	type: string;
	icon: string;
	label: string;
};

export const EngageHeader = ({
	language,
	pageModule,
	onBackClick,
	title,
	enforceLabelTitle = false,
	engageMeta
}: {
	language: LanguagesAbbr;
	pageModule?: PageModule;
	onBackClick: () => void;
	title?: string;
	enforceLabelTitle?: boolean;
	engageMeta?: EngageLabelInfo;
}) => {

	const historyState = useHistoryState<{ panelTitle: TranslateString | string }>();

	const labelInfo = useMemo(() => {
		if (engageMeta) {
			return engageMeta;
		}

		return {
			type: null,
			icon: ICONS.QUESTION_FILLED,
			label: title || 'Engage'
		};
	}, [engageMeta, title]);

	const renderTitle = useMemo(() => {
		if (historyState?.panelTitle) {
			if (typeof historyState.panelTitle === 'string') {
				return historyState.panelTitle;
			} else {
				return historyState.panelTitle[language] ?? historyState.panelTitle.base;
			}
		}

		if (enforceLabelTitle) return title;

		if (pageModule?.content?.custom_tab) {
			if (pageModule?.content?.custom_heading[language]) {
				return pageModule.content.custom_heading[language];
			} else if (pageModule?.content?.custom_heading.base) {
				return pageModule.content.custom_heading.base;
			}
		}

		if ((pageModule?.type === PageModuleType.questions || pageModule?.type === PageModuleType.comment_box_prompt) && pageModule?.modules?.length) {
			return pageModule?.modules[0]?.title?.[language] ?? pageModule?.modules[0]?.title.base;
		}

		if (pageModule?.type === PageModuleType.survey && pageModule?.modules?.length) {
			return pageModule?.modules[0]?.name?.[language] ?? pageModule?.modules[0]?.name.base;
		}

		return title;
	}, [
		historyState,
		enforceLabelTitle,
		title,
		pageModule,
		language
	]);

	return (
		<div className="engage header">
			<div className="title">
				<button
					className="no-style engage-back-button"
					onClick={onBackClick}>
					<Icon name={ICONS.ARROW_LEFT} size={16} color={COLORS.WHITE} />
				</button>
				{labelInfo.type &&
					<span className={classNames('e-engage-label', labelInfo.type)}>
						<Icon name={labelInfo.icon} size={12} />
						{labelInfo.label}
					</span>
				}
				<h6>
					{renderTitle}
				</h6>
			</div>
		</div>
	);
};
